class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));

    /*
     * --------------------------------------------------------------
     * CRAZYFLORA: DRAWER RETIRED IN FAVOUR OF A DEDICATED CART PAGE
     * --------------------------------------------------------------
     * The cart icon (#cart-icon-bubble, in cf-header.liquid) is now a
     * plain link to {{ routes.cart_url }} -- no click is intercepted
     * here anymore, so it just navigates to the real cart page.
     *
     * This custom element is still rendered in the DOM (from
     * layout/theme.liquid) purely so product-form.js finds a
     * `this.cart` target on add-to-cart. Without it, product-form.js
     * treats every add-to-cart as needing a full page reload to
     * /cart; with it (but never opened), the add stays a smooth AJAX
     * call and the item never pops anything open. See renderContents()
     * below for the bug this used to cause on every single add.
     * --------------------------------------------------------------
     */
  }

  open() {
    // No-op: the drawer UI is retired. Left in place (rather than
    // removed) so any existing call site fails safe instead of
    // throwing.
    return;
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    /*
     * --------------------------------------------------------------
     * WHY THIS USED TO BREAK "ADD TO CART" SITE-WIDE
     * --------------------------------------------------------------
     * The stock version of this method replaced the innerHTML of two
     * elements using server-rendered section HTML keyed by section id
     * "cart-drawer" and "cart-icon-bubble". Neither id is an actual
     * live Shopify section on this theme:
     *
     *   - layout/theme.liquid renders the cart drawer with
     *     {% render 'cart-drawer' %} (a snippet include), not
     *     {% section 'cart-drawer' %}, so there is no live section
     *     instance with id "cart-drawer" for Shopify's AJAX sections
     *     endpoint to re-render.
     *   - "cart-icon-bubble" isn't placed anywhere either -- the
     *     active custom header (cf-header.liquid) renders its own
     *     inline count badge and keeps it in sync independently (see
     *     its PUB_SUB_EVENTS.cartUpdate subscriber, further down in
     *     that file).
     *
     * Because of that, parsedState.sections['cart-drawer'] was always
     * undefined. The old code did:
     *
     *   sectionElement.innerHTML =
     *     new DOMParser().parseFromString(undefined, 'text/html')
     *       .querySelector('#CartDrawer').innerHTML;
     *
     * ...which throws (querySelector on the parsed "undefined" text
     * never finds #CartDrawer, so .innerHTML is called on null). That
     * threw on the very first loop iteration of EVERY add-to-cart,
     * before the drawer ever opened or the count ever updated. The
     * network request to Shopify succeeded every time; this function
     * silently crashed right after, which is why Add to Cart looked
     * broken with no visible error.
     *
     * Fix: since the drawer is retired anyway, there is nothing left
     * to render here. product-form.js already calls
     * publish(PUB_SUB_EVENTS.cartUpdate, ...) right before this method
     * runs, and cf-header.liquid's own listener updates the visible
     * count badge from that -- so cart state still stays in sync on
     * every add, it just no longer touches this drawer at all.
     * --------------------------------------------------------------
     */
    this.productId = parsedState && parsedState.id;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
